import {OggettoConfig} from "src/app/shared/_services/dynamic-crud.service";
import {CampoAggiuntivo} from "../../../app/shared/models/campo-aggiuntivo";
import {AddButtonCard, ImageUrl, productCrudUtility} from "./ProductUtility";

function Preferiti() {
  var OBJ: OggettoConfig = {
    Id: "favorites",
    RestRoute: '/prodotti',
    listView: 'card',
    ListResponseHasData:true,
    ListDefaultFilter: {preferiti:true,},
    PrintHeaders:[],
    cardPerRow:6,
    listClass: 'list-preferiti',
    listTitle: 'I tuoi preferiti',
    listSubtitle: 'articoli salvati',
    hasHeader: true,
    hasViewSwitch: true,
    cardButtons: productCrudUtility(true).cardButtons,
    Filters:[
    ],
    cardClass:'card-small',

    ImageUrl: productCrudUtility(true).ImageUrl,
    Headers: [

      CampoAggiuntivo.TextField("Prodotto", 'prodotto', "",{
        modificabile:false,
        style:{

         ' font-size': '13px',
  'font-weight': '700',
  'color': '#0F172A',
  'white-space': 'nowrap',
  'overflow': 'hidden',
  'text-overflow': 'ellipsis',
  'margin-bottom': '2px',
        }
      }),
       {
        nome: "Marca",
        oggetti: ["marcaObject"],
        type: 'object',
        field: ['label'],
        style: {

          'font-size':' 10.5px',
          'font-weight': '800',
          'color': 'var(--main-color)',
          'text-transform': 'uppercase',
          'letter-spacing': '.4px',
          'margin-bottom': '2px',
        }
      },
      // CampoAggiuntivo.TextField("Descrizione", 'descrizione', "",{
      //   modificabile:false,
      //   style:{
      //
      //     ' font-size': '11.5',
      //
      //     'color': '#64748b',
      //     'white-space': 'nowrap',
      //     'overflow': 'hidden',
      //     'text-overflow': 'ellipsis',
      //     'margin-bottom': '5px',
      //   }
      // }),
      CampoAggiuntivo.TextField("Descrizione", 'prezzo', "",{
        modificabile:false,
        style:{
          ' font-size': '15.5',
          'font-weight': '900',
          'color': '#0F172A',
          'white-space': 'nowrap',
          'overflow': 'hidden',
          'text-overflow': 'ellipsis',
          'margin-bottom': '5px',
        }
      })
    ],
    AzioniLista:[
      productCrudUtility(true).AddButtonCard
    ],
    MenuItems:[
      {
        path: 'shared/dynamiclist/favorites',
        title: "Preferiti",
        icon: "fas fa-cart",
        class: "",
        capacita: [],
      }
    ]
  }
  return OBJ;
}


export var PreferitiEnv = () => {
  var env: any = {
    Modules: {
      "Preferiti": true
    },
    Cruds: [Preferiti()],
    Menu: [...Preferiti().MenuItems]
  }
  return env;

}
